import * as React from "react"

import { SvgIconProps } from "styleguide/components/Svg/SvgIcon/SvgIcon"

import { Svg } from "styleguide/components"
import { uiColorToBaseColor } from "styleguide/styles/colors"

const IconKnowledgeSharing = ({
  title = "Knowledge sharing",
  color = "gray",
  viewBoxWidth = 40,
  viewBoxHeight = 40,
  ...otherProps
}: SvgIconProps) => (
  <Svg.Icon {...{ title, viewBoxHeight, viewBoxWidth, ...otherProps }}>
    <g fill="none" fillRule="evenodd">
      <circle fill={uiColorToBaseColor(color)} cx="20" cy="20" r="20" />
      <path
        d="M26 14a1 1 0 011 1v14a1 1 0 01-1 1H14a1 1 0 01-1-1V15a1 1 0 011-1h12zm-4.5 10h-5a.5.5 0 00-.492.41L16 24.5v1a.5.5 0 00.41.492l.09.008h5a.5.5 0 00.492-.41L22 25.5v-1a.5.5 0 00-.5-.5zm2-3h-7a.5.5 0 00-.492.41L16 21.5v1a.5.5 0 00.41.492l.09.008h7a.5.5 0 00.492-.41L24 22.5v-1a.5.5 0 00-.5-.5zm0-3h-7a.5.5 0 00-.492.41L16 18.5v1a.5.5 0 00.41.492l.09.008h7a.5.5 0 00.492-.41L24 19.5v-1a.5.5 0 00-.5-.5zM20 6l3 3-.75.75L20.5 8v4h-1V8l-1.75 1.75L17 9l3-3z"
        fill="#FFF"
      />
    </g>
  </Svg.Icon>
)

export default IconKnowledgeSharing
